import { Injectable } from '@angular/core';
import {
	ApiService,
	ExportDataRequest,
	PagedQueryParameter,
	PagedResponse,
	ReportBalanceDto,
	ReportNRTransactionDto,
	ReportSettingsDto,
	ReportSettingsShortDto,
	ReportTransactionHistoryDto,
	OperatorUserPOSDto,
	NegativeCardScanDto
} from '@nstep-common/core';
import { Any } from '@nstep-common/utils';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ReportingService {

	reportTemplateDataType: { [key: number]: { new(): any } } = {
		1: ReportBalanceDto,
		2: ReportNRTransactionDto,
		3: ReportTransactionHistoryDto,
		4: OperatorUserPOSDto,
		5: NegativeCardScanDto
	};

	constructor(private apiService: ApiService) {
	}

	getDefaultData(): Observable<any> {
		return this.apiService.get(Any, 'reporting/default-data');
	}

	invalidateDefaultDataCache(): void {
		this.apiService.invalidateCache('reporting/default-data');
	}

	getReports(model: PagedQueryParameter): Observable<PagedResponse<ReportSettingsShortDto>> {
		return this.apiService.getPage([ReportSettingsShortDto], 'reporting', model);
	}

	getReportSettings(reportId: number): Observable<ReportSettingsDto> {
		return this.apiService.get(ReportSettingsDto, `reporting/${reportId}`);
	}

	getReportTemplate(templateId: number, model: PagedQueryParameter): Observable<PagedResponse<any>> {
		const mapType = this.reportTemplateDataType[templateId];
		return this.apiService.postPage([mapType], `reporting/${templateId}`, model);
	}

	exportReportTemplate(reportId: number, model: ExportDataRequest): Observable<any> {
		return this.apiService.post(Any, `reporting/${reportId}/export`, model, { observe: 'response', responseType: 'blob' });
	}
}